import type { WatchFinding } from './types';

export const FINDING_TYPE_INVESTIGATION = 'investigation_conclusion';
export const WATCH_TOWER_KIND_COMPETITOR = 'potential_competitor';
export const EVENT_KIND_COMPETITOR = 'competitor';

function payloadNumber(payload: Record<string, unknown> | null, key: string): number | null {
  if (!payload) {
    return null;
  }
  const value = payload[key];
  if (typeof value === 'number' && Number.isFinite(value)) {
    return value;
  }
  if (typeof value === 'string' && value.trim() && Number.isFinite(Number(value))) {
    return Number(value);
  }
  return null;
}

function payloadString(payload: Record<string, unknown> | null, key: string): string | null {
  if (!payload) {
    return null;
  }
  const value = payload[key];
  return typeof value === 'string' && value.trim() ? value.trim() : null;
}

export function isInvestigationConclusion(finding: WatchFinding): boolean {
  return finding.findingType === FINDING_TYPE_INVESTIGATION;
}

export function watchTowerKind(finding: WatchFinding): string | null {
  return payloadString(finding.payloadJson, 'watchTowerKind');
}

export function isPotentialCompetitor(finding: WatchFinding): boolean {
  return watchTowerKind(finding) === WATCH_TOWER_KIND_COMPETITOR;
}

export function relatedWatchCompanyIdFromFinding(finding: WatchFinding): number | null {
  return payloadNumber(finding.payloadJson, 'relatedWatchCompanyId');
}
